import { FilterButtonGroup } from '@shared/components';

export type BlockRecordActiveTypeTabValue = 'active' | 'in-active';

const TAB_ITEMS: { value: BlockRecordActiveTypeTabValue; label: string }[] = [
  { label: 'รายการที่ถูกระงับสิทธิ์', value: 'active' },
  { label: 'ประวัติการถูกระงับสิทธิ์', value: 'in-active' },
];

interface BlockRecordActiveTypeTabsProps {
  value: BlockRecordActiveTypeTabValue;
  onChange: (value: BlockRecordActiveTypeTabValue) => void;
}

export default function BlockRecordActiveTypeTabs(props: Readonly<BlockRecordActiveTypeTabsProps>) {
  const { value, onChange } = props;

  return (
    <FilterButtonGroup
      items={TAB_ITEMS}
      value={value}
      onChange={(value) => {
        onChange(value as BlockRecordActiveTypeTabValue);
      }}
    />
  );
}
